import { historySubjectIdsOf } from "../utils/historySubjectIdsOf";
import type { HistoryPageCursor, HistorySubject } from "../types";

export const historyKeys = {
  all: ["quantitySurveyorHistory"] as const,
  // A null subject lists the whole project.
  list: (
    projectId: number,
    subject: HistorySubject | null,
    { page, snapshotMaxId }: HistoryPageCursor,
  ) => {
    const { floorPlanId, diagramId } = historySubjectIdsOf(subject);
    return [
      ...historyKeys.all,
      "list",
      projectId,
      floorPlanId,
      diagramId,
      page,
      snapshotMaxId,
    ] as const;
  },
  ownUndo: (
    projectId: number,
    subject: HistorySubject | null,
    userId: number | null,
  ) => {
    const { floorPlanId, diagramId } = historySubjectIdsOf(subject);
    return [
      ...historyKeys.all,
      "ownUndo",
      projectId,
      floorPlanId,
      diagramId,
      userId,
    ] as const;
  },
};
